// Arabic operations-console strings — DEVELOPMENT DRAFT by Claude (PD-011); unreviewed until decision H-10.
import type { enOpsui } from './en-opsui.ts';
import type { Message } from './types.ts';

export const arOpsui: { readonly [K in keyof typeof enOpsui]: Message } = {
  'api.opsuiImpactReview': 'يؤثر هذا التغيير في زيارات مخطط لها. راجِع الزيارات المتأثرة ثم أكِّد.',
  'api.opsuiImpactStale': 'تغيّرت الزيارات المتأثرة منذ مراجعتك. راجِعها مرة أخرى ثم أكِّد.',
  'api.opsuiClosureRemoved': 'أُزيل هذا الإغلاق من قبل.',
  'api.opsuiOutcomeUnknown': 'نتيجة هذه المهمة لدى المزوّد غير معروفة. اقرأها من المزوّد أو سوِّها أولًا؛ فإعادة التشغيل قد تكرر الأثر.',
  'v.opsuiImpactToken': 'مرجع مراجعة الأثر غير صالح. تحقّق من الأثر مرة أخرى.',
  'v.opsuiFallbackAfterHost': 'يجب أن يأتي التنبيه البديل بعد تذكير المضيف.',
  'v.opsuiDuplicateSite': 'لا يمكن أن يظهر الموقع إلا مرة واحدة.',
  'v.opsuiContactNotEligible': 'اختر شخصًا يمكنه العمل في الاستقبال في هذا الموقع حاليًا.',
  'v.opsuiHours.day': 'استخدم يومًا من الاثنين إلى الأحد.',
  'v.opsuiHours.format': 'استخدم صيغة 24 ساعة، مثل 08:30.',
  'v.opsuiHours.order': 'يجب أن يكون وقت الإغلاق بعد وقت الفتح (00:00 تعني منتصف الليل في نهاية اليوم).',
  'v.opsuiHours.overlap': 'تتداخل هذه الفترة مع فترة أخرى في اليوم نفسه.',
  'v.opsuiClosure.dates': 'استخدم تواريخ بصيغة YYYY-MM-DD.',
  'v.opsuiClosure.order': 'يجب أن يكون اليوم الأخير في اليوم الأول أو بعده.',
  'v.opsuiClosure.too_long': 'لا يمكن أن يتجاوز الإغلاق سنة واحدة.',
  'v.opsuiClosure.hours_required': 'تحتاج الساعات المخفّضة إلى وقت فتح ووقت إغلاق.',
  'v.opsuiClosure.hours_not_allowed': 'أوقات الفتح متاحة لأيام الساعات المخفّضة فقط.',
  'v.opsuiClosure.hours_order': 'يجب أن يكون وقت الإغلاق بعد وقت الفتح.',
  'v.opsuiClosure.overlap': 'تتداخل هذه التواريخ مع إغلاق آخر لهذا الموقع.',

  'opsui.tab.hours': 'الساعات والقواعد',
  'opsui.tab.batch': 'تغييرات متعددة المواقع',
  'opsui.col.action': 'الإجراء',

  'opsui.impact.check': 'تحقّق من الأثر على الزيارات المخطط لها',
  'opsui.impact.none': 'لا تتأثر أي زيارة مخطط لها. الزيارات الواقعة أصلًا خارج الساعات الحالية: {already}.',
  'opsui.impact.title': { zero: 'لا توجد زيارات خارج الساعات', one: 'زيارة مخطط لها واحدة ستقع خارج الساعات', two: 'زيارتان مخطط لهما ستقعان خارج الساعات', few: '{count} زيارات مخطط لها ستقع خارج الساعات', many: '{count} زيارة مخطط لها ستقع خارج الساعات', other: '{count} زيارة مخطط لها ستقع خارج الساعات' },
  'opsui.impact.body': 'لا يُلغى شيء ولا يُنقل. تحتفظ الزيارات بأوقاتها؛ أبلِغ المضيفين إذا لزم تغيير الخطط.',
  'opsui.impact.more': { one: 'وزيارة أخرى', two: 'وزيارتان أخريان', few: 'و{count} زيارات أخرى', many: 'و{count} زيارة أخرى', other: 'و{count} زيارة أخرى' },
  'opsui.impact.truncated': 'توجد زيارات مستقبلية أكثر مما فُحص؛ قد يكون العدد أكبر.',
  'opsui.impact.ack': { one: 'راجعتُ الزيارة المتأثرة', two: 'راجعتُ الزيارتين المتأثرتين', few: 'راجعتُ {count} زيارات متأثرة', many: 'راجعتُ {count} زيارة متأثرة', other: 'راجعتُ {count} زيارة متأثرة' },
  'opsui.reason.closure': 'الموقع مغلق (إغلاق أو عطلة)',
  'opsui.reason.closed_day': 'الموقع مغلق في ذلك اليوم',
  'opsui.reason.outside_hours': 'خارج ساعات العمل',

  'opsui.hours.title': 'ساعات العمل',
  'opsui.hours.sub': 'بالتوقيت المحلي في {zone}. لا تغيّر تحويلات التوقيت الصيفي هذه الأوقات.',
  'opsui.hours.unset': 'لم تُحدَّد ساعات عمل، لذا يُعامل الموقع على أنه مفتوح في أي وقت.',
  'opsui.hours.day': 'اليوم',
  'opsui.hours.ranges': 'مفتوح',
  'opsui.hours.closed': 'مغلق',
  'opsui.hours.open': 'يفتح',
  'opsui.hours.close': 'يغلق',
  'opsui.hours.addRange': 'إضافة ساعات',
  'opsui.hours.removeRange': 'إزالة',
  'opsui.hours.midnight': 'استخدم 00:00 وقتًا للإغلاق عند منتصف الليل في نهاية اليوم. للعمل الليلي أضِف ساعات في اليومين.',
  'opsui.hours.save': 'حفظ ساعات العمل',
  'opsui.hours.saved': 'حُفظت ساعات العمل.',

  'opsui.closures.title': 'الإغلاقات والعطل',
  'opsui.closures.sub': 'أيام محلية كاملة. تحلّ الساعات المخفّضة محل الساعات الأسبوعية في تلك الأيام.',
  'opsui.closures.none': 'لا توجد إغلاقات أو عطل مخطط لها.',
  'opsui.closures.label': 'الاسم',
  'opsui.closures.kind': 'النوع',
  'opsui.closures.dates': 'التواريخ',
  'opsui.closures.from': 'اليوم الأول',
  'opsui.closures.to': 'اليوم الأخير',
  'opsui.closures.localDates': 'تواريخ محلية في {zone}.',
  'opsui.closures.add': 'إضافة إغلاق',
  'opsui.closures.remove': 'إزالة',
  'opsui.closures.removeTitle': 'إزالة الإغلاق',
  'opsui.kind.holiday': 'عطلة رسمية',
  'opsui.kind.closure': 'إغلاق الموقع',
  'opsui.kind.reduced_hours': 'ساعات مخفّضة',

  'opsui.rules.title': 'متابعة الاستقبال',
  'opsui.rules.sub': 'من يُبلَّغ عندما ينتظر زائر طويلًا، أو عندما لا يُسجَّل خروج بعد انتهاء الزيارة.',
  'opsui.rules.effective': 'المعمول به الآن: تذكير المضيف بعد {host} دقيقة، والتنبيه البديل بعد {fallback} دقيقة.',
  'opsui.rules.waitingEnabled': 'ذكّر المضيف ثم جهة اتصال بديلة عندما ينتظر الزائر طويلًا',
  'opsui.rules.hostMinutes': 'ذكّر المضيف بعد (دقائق)',
  'opsui.rules.fallbackMinutes': 'نبّه الجهة البديلة بعد (دقائق)',
  'opsui.rules.default': 'اتركه فارغًا لاستخدام القيمة الافتراضية ({minutes} دقيقة).',
  'opsui.rules.lead': 'جهة الاتصال البديلة (مسؤول الاستقبال)',
  'opsui.rules.leadHint': 'يُبلَّغ المضيفون المشاركون في الزيارة أيضًا. يُرسل كل إشعار مرة واحدة.',
  'opsui.rules.overstayEnabled': 'أبلِغ المضيف ومسؤول الموقع عندما لا يُسجَّل خروج بعد انتهاء الزيارة',
  'opsui.rules.owner': 'مسؤول الموقع',
  'opsui.rules.ownerHint': 'يُسمّى في مهام متابعة تجاوز المدة. لا يذكر الإشعار أبدًا أن الزائر غادر.',
  'opsui.rules.none': 'لا أحد',
  'opsui.rules.contactUnavailable': 'لم يعد متاحًا',
  'opsui.rules.save': 'حفظ قواعد المتابعة',
  'opsui.rules.saved': 'حُفظت قواعد المتابعة.',

  'opsui.esc.title': 'متابعات الاستقبال الأخيرة',
  'opsui.esc.sub': 'كل حدّ يُبلِّغ مرة واحدة. لا تغيّر نتائج التسليم أي وصول أو حضور.',
  'opsui.esc.none': 'لم تكن هناك حاجة إلى متابعة مؤخرًا.',
  'opsui.esc.noAccess': 'يتطلب سجل متابعة الاستقبال صلاحية الاستقبال في هذا الموقع.',
  'opsui.esc.kind': 'المتابعة',
  'opsui.esc.due': 'بلوغ الحد',
  'opsui.esc.notices': 'الإشعارات',
  'opsui.esc.after': 'بعد {minutes} دقيقة',
  'opsui.esc.pending': 'بانتظار الإرسال',
  'opsui.esc.k.waiting_host': 'تذكير المضيف بانتظار طويل',
  'opsui.esc.k.waiting_fallback': 'إبلاغ الجهة البديلة بانتظار طويل',
  'opsui.esc.k.overstay': 'لا خروج مسجّل بعد انتهاء الزيارة',
  'opsui.msg.queued': 'في قائمة الانتظار',
  'opsui.msg.accepted': 'أُرسل',
  'opsui.msg.failed': 'فشل (ستُعاد المحاولة)',
  'opsui.msg.blocked': 'لم يُرسل',

  'opsui.tz.visits': { zero: 'لا تتأثر أي زيارة مخطط لها.', one: 'تحتفظ زيارة مخطط لها واحدة بوقتها الدقيق؛ وتتغير قراءتها المحلية كما هو موضح.', two: 'تحتفظ زيارتان مخطط لهما بوقتيهما الدقيقين؛ وتتغير قراءتاهما المحليتان كما هو موضح.', few: 'تحتفظ {count} زيارات مخطط لها بأوقاتها الدقيقة؛ وتتغير قراءاتها المحلية كما هو موضح.', many: 'تحتفظ {count} زيارة مخطط لها بأوقاتها الدقيقة؛ وتتغير قراءاتها المحلية كما هو موضح.', other: 'تحتفظ {count} زيارة مخطط لها بأوقاتها الدقيقة؛ وتتغير قراءاتها المحلية كما هو موضح.' },

  'opsui.batch.title': 'تغييرات متعددة المواقع',
  'opsui.batch.intro': 'طبّق تغييرًا واحدًا على عدة مواقع. يُفحص كل موقع وحده ويحصل على نتيجته الخاصة.',
  'opsui.batch.change': 'التغيير',
  'opsui.batch.changeSub': 'اختر ما تريد تغييره والمواقع التي سيُطبّق عليها.',
  'opsui.batch.kind': 'ما الذي تريد تغييره',
  'opsui.batch.k.operating_hours': 'ساعات العمل',
  'opsui.batch.k.operating_rules': 'قواعد متابعة الاستقبال',
  'opsui.batch.k.branding_colour': 'لون الهوية',
  'opsui.batch.colour': 'لون الهوية',
  'opsui.batch.colourHint': 'يجب أن يبقى النص الأبيض مقروءًا عليه.',
  'opsui.batch.keepBlank': 'اتركه فارغًا للإبقاء على قيمة كل موقع.',
  'opsui.batch.keep': 'أبقِ إعداد كل موقع',
  'opsui.batch.on': 'مفعّل',
  'opsui.batch.off': 'معطّل',
  'opsui.batch.days': 'مفتوح في',
  'opsui.batch.sites': 'المواقع',
  'opsui.batch.preview': 'معاينة لكل موقع',
  'opsui.batch.previewTitle': 'المعاينة',
  'opsui.batch.previewSub': 'المواقع المرفوضة هنا لن تتغير.',
  'opsui.batch.site': 'الموقع',
  'opsui.batch.outcome': 'النتيجة',
  'opsui.batch.impact': 'الزيارات المخطط لها',
  'opsui.batch.version': 'الإصدار',
  'opsui.batch.reasonHint': 'يُسجَّل في سجل التدقيق لكل موقع.',
  'opsui.batch.apply': { one: 'تطبيق على موقع واحد', two: 'تطبيق على موقعين', few: 'تطبيق على {count} مواقع', many: 'تطبيق على {count} موقعًا', other: 'تطبيق على {count} موقع' },
  'opsui.batch.resultTitle': 'النتيجة لكل موقع',
  'opsui.batch.history': 'آخر التغييرات متعددة المواقع',
  'opsui.batch.noHistory': 'لا توجد تغييرات متعددة المواقع بعد.',
  'opsui.batch.applied': 'طُبّق على {applied} من {total} مواقع',
  'opsui.batch.unknownSite': 'الموقع غير متاح',
  'opsui.batch.o.ready': 'جاهز',
  'opsui.batch.o.applied': 'طُبّق',
  'opsui.batch.o.unchanged': 'مضبوط مسبقًا',
  'opsui.batch.o.impact_review_required': 'راجِع الزيارات المخطط لها',
  'opsui.batch.o.forbidden': 'غير مسموح',
  'opsui.batch.o.not_found': 'غير متاح',
  'opsui.batch.o.version_conflict': 'تغيّر في الأثناء',
  'opsui.batch.o.invalid': 'غير صالح هنا',
  'opsui.batch.o.failed': 'فشل',
  'opsui.batch.p.hours': 'الساعات غير صالحة.',
  'opsui.batch.p.fallback_before_host': 'سيأتي التنبيه البديل قبل تذكير المضيف.',
  'opsui.batch.p.contrast': 'لن يكون النص الأبيض مقروءًا على هذا اللون.',
  'opsui.batch.s.completed': 'اكتمل',
  'opsui.batch.s.partial': 'طُبّق جزئيًا',
  'opsui.batch.s.failed': 'لم يُطبّق شيء',
  'opsui.batch.s.unchanged': 'لا شيء لتغييره',

  'opsui.topics.title': 'قوائم الانتظار حسب الموضوع',
  'opsui.topics.sub': 'الأعمال التي لم تُسلَّم بعد ضمن نطاقك: كم عددها، وكم انتظر أقدمها.',
  'opsui.topics.none': 'لا توجد أعمال غير مسلّمة.',
  'opsui.topics.topic': 'الموضوع',
  'opsui.topics.due': 'مستحق الآن',
  'opsui.topics.retrying': 'قيد إعادة المحاولة',
  'opsui.topics.scheduled': 'مجدول',
  'opsui.topics.inFlight': 'قيد التنفيذ',
  'opsui.topics.dead': 'رسائل متعذّرة',
  'opsui.topics.age': 'أقدم مستحق',
  'opsui.topics.oldestDead': 'الأقدم {time}',
  'opsui.err.timeout': 'انتهاء المهلة',
  'opsui.err.unavailable': 'غير متاح',
  'opsui.err.rejected': 'مرفوض',
  'opsui.err.invalid': 'غير صالح',
  'opsui.err.conflict': 'تعارض',
  'opsui.err.restore_fence': 'محجوز بعد الاستعادة',
  'opsui.err.outcome_unknown': 'النتيجة غير معروفة',
  'opsui.err.other': 'خطأ آخر',
  'opsui.ext.title': '{kind}: {state}',
  'opsui.ext.k.credential_operation': 'عملية بيانات اعتماد',
  'opsui.ext.k.gate_command': 'أمر الحاجز',
  'opsui.ext.s.queued': 'في قائمة الانتظار',
  'opsui.ext.s.dispatched': 'أُرسل دون رد مسجّل (إعادة التشغيل تجعله غير معروف وتقرؤه من المزوّد؛ ولا تعيد الإرسال أبدًا)',
  'opsui.ext.s.acknowledged': 'مُستلَم',
  'opsui.ext.s.confirmed': 'مؤكَّد',
  'opsui.ext.s.failed': 'فشل',
  'opsui.ext.s.unknown': 'النتيجة غير معروفة',
  'opsui.ext.s.reconciling': 'قيد القراءة من المزوّد',
  'opsui.ext.blocked': 'إعادة التشغيل محظورة حتى تحسم القراءة من المزوّد أو التسوية النتيجة.',
  'opsui.ext.settled': 'نتيجة المزوّد محسومة؛ لا يمكن لإعادة التشغيل أن تكرر أثرًا غير معروف.',
};
